G.Jam = function(layer, cellX, cellY, hp) {
  G.BoardToken.call(this, layer, {
    tokenType: "jam"
  }, cellX, cellY, hp);

  G.changeTexture(this, "jam_"+this.hp);
};

G.Jam.prototype = Object.create(G.BoardToken.prototype);

G.Jam.prototype.onHit = function() {

  G.sb("hitJam").dispatch(this);
  // G.sb("fx").dispatch('burstConcrete',this,this.hp);
  G.sfx.explosion_subtle.play();
  this.hp--;

  // G.sb("fxTop").dispatch('burstConcreteAnim',this,this);

  // G.sfx.brick_break.play();
  if (this.hp == 0) {
    this.remove();
    var candy = this.board.removeCandy(this.cellX, this.cellY, true);
  }else {
    G.changeTexture(this,'jam_'+this.hp);
  }
};

G.Jam.prototype.increaseHp = function() {
  this.hp++;
  G.changeTexture(this,'jam_'+this.hp);
};

G.Jam.prototype.onBoosterUse = function() {
  this.onHit();
  return false;
};